module.exports = __webpack_public_path__ + "static/media/logo-white.71f5b727.png";